var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 89,
  height: 62,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00C29C",
  d: "M37.108 28.706 3.57 58.6h82.39L51.691 28.706l-8.02 3.646-6.563-3.646Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00C29C",
  d: "M2.84 57.87V3.918l34.998 24.79L2.84 57.87Zm83.848 0V3.918l-34.997 24.79L86.688 57.87Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3855",
  d: "M84.5 3.187H4.299L44.4 32.352 84.5 3.187Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E1E1E",
  stroke: "#1E1E1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M4.508 1C2.316 1 .653 2.995.653 5.306v51.388C.653 59.005 2.316 61 4.508 61h79.984c2.191 0 3.855-1.995 3.855-4.306V5.306C88.347 2.995 86.683 1 84.492 1H4.508ZM4.01 54.82V6.87l30.752 21.637L4.01 54.821Zm40.166-24.445-5.023-3.535a1.808 1.808 0 0 0-.486-.342L7.639 4.667h73.13L44.807 30.372a.527.527 0 0 1-.63.003ZM81.88 57.333H7.009L38.019 30.8l4.182 2.943c1.408.99 3.202.983 4.603-.019l4.257-3.042L81.88 57.333Zm3.11-50.905v48.496l-30.701-26.55L84.99 6.427Z"
})));
export { SvgEmail as Svg };